import React, { useState, useEffect } from "react";
import Proptypes from "prop-types";
import FieldLabel from "@shared/v2/FieldLabel";
import DatePicker from "@shared/v2/DatePicker/DatePicker";
import Dropdown from "@shared/v2/Dropdown";
import { useEventListenerAction } from "@shared/hooks/useEventListenerAction";
import { CLEAR_MODAL_FILTER_ID } from "../../shared/constants";

const AgreementDateSelect = ({
  previousSelectedExpirationDate,
  previousSelectedSignedDate,
  expirationDateOptions,
  signedDateOptions,
  previousSelectedSignedStartDate,
  previousSelectedSignedEndDate,
  previousSelectedExpirationStartDate,
  previousSelectedExpirationEndDate,
}) => {
  const [selectedSignedDate, setSelectedSignedDate] = useState(
    previousSelectedSignedDate?.length > 0
      ? signedDateOptions.find((option) => option.value === previousSelectedSignedDate[0])
      : [],
  );

  const [selectedSignedStartDate, setSelectedSignedStartDate] = useState(
    previousSelectedSignedStartDate?.length > 0 ? previousSelectedSignedStartDate[0] : [],
  );
  const [selectedSignedEndDate, setSelectedSignedEndDate] = useState(
    previousSelectedSignedEndDate?.length > 0 ? previousSelectedSignedEndDate[0] : [],
  );
  const [selectedExpirationStartDate, setSelectedExpirationStartDate] = useState(
    previousSelectedExpirationStartDate?.length > 0 ? previousSelectedExpirationStartDate[0] : [],
  );
  const [selectedExpirationEndDate, setSelectedExpirationEndDate] = useState(
    previousSelectedExpirationEndDate?.length > 0 ? previousSelectedExpirationEndDate[0] : [],
  );

  const [selectedExpiredDate, setSelectedExpiredDate] = useState(
    previousSelectedExpirationDate?.length > 0
      ? expirationDateOptions.find((option) => option.value === previousSelectedExpirationDate[0])
      : [],
  );

  useEventListenerAction(CLEAR_MODAL_FILTER_ID, () => {
    setSelectedExpiredDate([]);
    setSelectedSignedDate([]);
    setSelectedSignedStartDate([]);
    setSelectedSignedEndDate([]);
    setSelectedExpirationStartDate([]);
    setSelectedExpirationEndDate([]);
  });
  useEffect(() => {
    if (
      selectedSignedStartDate.length > 0 ||
      selectedSignedEndDate.length > 0 ||
      selectedExpirationStartDate.length > 0 ||
      selectedExpirationEndDate.length > 0
    ) {
      if (
        document.getElementById("leads_filter_selected_agreement_filters_custom_signed_start_date") != null
      ) {
        document.getElementById("leads_filter_selected_agreement_filters_custom_signed_start_date").value =
          selectedSignedStartDate || [];
      }

      if (document.getElementById("leads_filter_selected_agreement_filters_custom_signed_end_date") != null) {
        document.getElementById("leads_filter_selected_agreement_filters_custom_signed_end_date").value =
          selectedSignedEndDate || [];
      }

      if (
        document.getElementById("leads_filter_selected_agreement_filters_custom_expiration_start_date") !=
        null
      ) {
        document.getElementById(
          "leads_filter_selected_agreement_filters_custom_expiration_start_date",
        ).value = selectedExpirationStartDate || [];
      }

      if (
        document.getElementById("leads_filter_selected_agreement_filters_custom_expiration_end_date") != null
      ) {
        document.getElementById("leads_filter_selected_agreement_filters_custom_expiration_end_date").value =
          selectedExpirationEndDate || [];
      }
    }
  }, [
    selectedSignedStartDate,
    selectedSignedEndDate,
    selectedExpirationStartDate,
    selectedExpirationEndDate,
  ]);

  return (
    <div className="tw-mb-[10px]">
      <div>
        <Dropdown
          id="leads_filter_selected_agreement_filters_signed_date_range"
          name="leads_filter[selected_agreement_filters][signed_date_range][]"
          label="Signed Date Range"
          placeholder="Select"
          options={signedDateOptions}
          value={selectedSignedDate}
          onChange={(e) => setSelectedSignedDate(e)}
          menuPlacement="bottom"
          menuShouldComeToFront
        />
      </div>
      {selectedSignedDate?.value === "custom" && (
        <div className="tw-flex tw-gap-[16px] tw-pt-[16px]">
          <div className="tw-flex-1">
            <input
              type="hidden"
              id="leads_filter_selected_agreement_filters_custom_signed_start_date"
              name="leads_filter[selected_agreement_filters][custom_signed_start_date][]"
              value=""
            />

            <FieldLabel
              htmlFor="leads_filter_selected_agreement_filters_custom_signed_start_date"
              label="Signed Start"
            />
            <DatePicker
              inputProps={{
                placeholder: "MM/DD/YYYY",
                inputSize: "min",
                size: 17,
                readonly: false,
                required: true,
              }}
              onChange={(value) => setSelectedSignedStartDate([moment(value).format("YYYY-MM-DD")])}
              value={selectedSignedStartDate}
            />
          </div>
          <div className="tw-flex-1">
            <input
              type="hidden"
              id="leads_filter_selected_agreement_filters_custom_signed_end_date"
              name="leads_filter[selected_agreement_filters][custom_signed_end_date][]"
              value=""
            />

            <FieldLabel
              htmlFor="leads_filter_selected_agreement_filters_custom_signed_end_date"
              label="Signed End"
            />
            <DatePicker
              inputProps={{
                placeholder: "MM/DD/YYYY",
                inputSize: "min",
                size: 17,
                readonly: false,
                required: true,
              }}
              onChange={(value) => setSelectedSignedEndDate([moment(value).format("YYYY-MM-DD")])}
              value={selectedSignedEndDate}
            />
          </div>
        </div>
      )}
      <div className="tw-pt-[16px]">
        <Dropdown
          id="leads_filter_selected_agreement_filters_expiration_date_range"
          name="leads_filter[selected_agreement_filters][expiration_date_range][]"
          label="Expiration Date Range"
          placeholder="Select"
          options={expirationDateOptions}
          value={selectedExpiredDate}
          onChange={(e) => setSelectedExpiredDate(e)}
          menuPlacement="bottom"
          menuShouldComeToFront
        />
      </div>
      {selectedExpiredDate?.value === "custom" && (
        <div className="tw-flex tw-gap-[16px] tw-pt-[16px]">
          <div className="tw-flex-1">
            <input
              type="hidden"
              id="leads_filter_selected_agreement_filters_custom_expiration_start_date"
              name="leads_filter[selected_agreement_filters][custom_expiration_start_date][]"
              value=""
            />
            <FieldLabel
              htmlFor="leads_filter_selected_agreement_filters_custom_expiration_start_date"
              label="Expiration Start"
            />
            <DatePicker
              inputProps={{
                placeholder: "MM/DD/YYYY",
                inputSize: "min",
                size: 17,
                readonly: false,
                required: true,
              }}
              onChange={(value) => setSelectedExpirationStartDate([moment(value).format("YYYY-MM-DD")])}
              value={selectedExpirationStartDate}
            />
          </div>
          <div className="tw-flex-1">
            <input
              type="hidden"
              id="leads_filter_selected_agreement_filters_custom_expiration_end_date"
              name="leads_filter[selected_agreement_filters][custom_expiration_end_date][]"
              value=""
            />
            <FieldLabel
              htmlFor="leads_filter_selected_agreement_filters_custom_expiration_end_date"
              label="Expiration End"
            />
            <DatePicker
              inputProps={{
                placeholder: "MM/DD/YYYY",
                inputSize: "min",
                size: 17,
                readonly: false,
                required: true,
              }}
              onChange={(value) => setSelectedExpirationEndDate([moment(value).format("YYYY-MM-DD")])}
              value={selectedExpirationEndDate}
            />
          </div>
        </div>
      )}
    </div>
  );
};
AgreementDateSelect.propTypes = {
  previousSelectedExpirationDate: Proptypes.arrayOf(Proptypes.string),
  previousSelectedSignedDate: Proptypes.arrayOf(Proptypes.string),
  signedDateOptions: Proptypes.arrayOf(Proptypes.shape({ label: Proptypes.string, value: Proptypes.string })),
  expirationDateOptions: Proptypes.arrayOf(
    Proptypes.shape({ label: Proptypes.string, value: Proptypes.string }),
  ),
  previousSelectedSignedStartDate: Proptypes.arrayOf(Proptypes.string),
  previousSelectedSignedEndDate: Proptypes.arrayOf(Proptypes.string),
  previousSelectedExpirationStartDate: Proptypes.arrayOf(Proptypes.string),
  previousSelectedExpirationEndDate: Proptypes.arrayOf(Proptypes.string),
};
AgreementDateSelect.defaultProps = {
  previousSelectedExpirationDate: [],
  previousSelectedSignedDate: [],
  signedDateOptions: [],
  expirationDateOptions: [],
  previousSelectedSignedStartDate: [],
  previousSelectedSignedEndDate: [],
  previousSelectedExpirationStartDate: [],
  previousSelectedExpirationEndDate: [],
};
export default AgreementDateSelect;
